import React, { useState, useEffect } from 'react'
import { Col, Row } from "react-bootstrap";
import { useLocation } from 'react-router-dom';

const Footer = () => {
  const location = useLocation();
  const [marginLeft, setMarginLeft] = useState('0px');

  useEffect(() => {
    // Check if we're on a setup page
    const isSetupPage = location.pathname.includes('/setup/');

    if (isSetupPage) {
      // Check if sidebar is collapsed by looking at the sidebar element
      const sidebar = document.querySelector('.setup-dark-sidebar');
      if (sidebar) {
        const isCollapsed = sidebar.classList.contains('collapsed');
        setMarginLeft(isCollapsed ? '60px' : '240px');

        // Add a mutation observer to watch for sidebar collapse changes
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
              const isCollapsed = sidebar.classList.contains('collapsed');
              setMarginLeft(isCollapsed ? '60px' : '240px');
            }
          });
        });

        observer.observe(sidebar, { attributes: true });

        return () => observer.disconnect();
      }
    } else {
      setMarginLeft('0px');
    }
  }, [location.pathname]);

  return (
    <footer
      className="w-100 app-site-footer"
      style={{
        height: "40px",
        backgroundColor: "#f8f9fa",
        position: "fixed",
        zIndex: '999',
        bottom: "0px",
        borderTop: "1px solid #dee2e6",
        display: "flex",
        alignItems: "center",
        padding: "0 20px",
        marginLeft: marginLeft,
        width: `calc(100% - ${marginLeft})`,
        transition: "margin-left 0.3s ease, width 0.3s ease"
      }}
    >
      <Row className="g-0 w-100">
        <Col lg={12} xs={12} sm={12} className="text-center">
          <span style={{ fontSize: "13px", color: "#6c757d" }}>
            © Copyright
            <a
              href="https://vgrowcrm.com/"
              style={{
                color: "#0176d3",
                textDecoration: "none",
                fontWeight: "600",
                margin: "0 4px"
              }}
              onMouseEnter={(e) => e.target.style.textDecoration = "underline"}
              onMouseLeave={(e) => e.target.style.textDecoration = "none"}
            >
              zemneo
            </a>
            All Rights Reserved.
          </span>
        </Col>
      </Row>
    </footer>
  )
}

export default Footer
